export type QueryStringParams = Record<string, string | number | boolean | null | undefined>;

export const buildQueryString = (
  params: QueryStringParams
): string => {
  const queryParts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && String(value).length > 0)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );

  return queryParts.length > 0 ? `?${queryParts.join("&")}` : "";
};